<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-date-picker
                            v-model="weekValue"
                            type="week"
                            format="yyyy 第 WW 周" ref="week" placeholder="选择周" value-format="yyyy-MM-dd"
                            :picker-options="{'firstDayOfWeek': 1}" @change="selectWeek">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativeList">查询</el-button>
                </el-form-item>

            </el-form>
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="访谈人" prop="userName" width="100"></el-table-column>
                <el-table-column label="填写时间" prop="createTime"></el-table-column>
                <el-table-column label="用户类型" prop="customerType"></el-table-column>
                <el-table-column label="访谈时间" prop="customerPic"></el-table-column>
                <el-table-column label="获得赞数" prop="customerVote"></el-table-column>
                <!--<el-table-column label="操作" fixed="right">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-button v-if="scope.row.isEdit==1" type="danger" size="mini" @click="getCooperativeQues(scope.row.id,scope.row.isEdit,scope.row.isVote,scope.row.periodId)">修改</el-button>-->
                        <!--<el-button v-if="scope.row.isEdit==0" type="success" size="mini" @click="getCooperativeQues(scope.row.id,scope.row.isEdit,scope.row.isVote,scope.row.periodId)">查看</el-button>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>

        </div>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    :hide-on-single-page="formInline.pageSize>=recordsTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-drawer
                title="访谈内容(*必填)"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose" size="70%">
            <div style="padding: 5px 20px;">
                <template v-for="(item,index) in quesList">
                    <div>
                        <p>
                            <span><b style="color: red">{{item.required==1?'*':''}}</b>{{index+1}} .</span>
                            <span>{{item.questionName}}</span>
                        </p>
                        <p style="font-size: 10px;color:grey">{{item.questionDesc}}</p>
                        <div>
                            <template v-if="item.questionType==2">
                                <el-select v-model="item.answer" clearable placeholder="请选择" @change="formSubmit(item)">
                                    <el-option
                                            v-for="opt in JSON.parse(item.questionOption)"
                                            :key="opt.code"
                                            :label="opt.name"
                                            :value="opt.code" :disabled="editIs==0">
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.questionType==3">
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadFile"
                                        :on-success="handleFileChange"
                                        :on-preview="handleFileView"
                                        :on-remove="handleFileRemove"
                                        :file-list="fileObjList" :disabled="editIs==0">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </template>
                            <template v-else-if="item.questionType==4">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-select v-model="item.answer"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch"
                                                   @change="formSubmit(item)"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0">
                                            <el-option
                                                    v-for="user in selectUserList"
                                                    :key="user.USER_ID"
                                                    :label="user.USER_NAME"
                                                    :value="user.USER_ID">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-else-if="item.questionType==5">
                                <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                    <el-col :sm="10" :xs="24">
                                        <el-select v-model="rel.relationUserId"
                                                   filterable
                                                   remote
                                                   clearable
                                                   reserve-keyword
                                                   :remote-method="querySearch1"
                                                   @change="formSubmit(item)"
                                                   @focus="selectFocus(relIndex)"
                                                   ref="select"
                                                   placeholder="请输入同事姓名或邮箱" :disabled="editIs==0">
                                            <template v-if="currentSelectIndex==relIndex">
                                                <el-option
                                                        v-for="user in selectUserList1"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>
                                            <template v-else>
                                                <el-option
                                                        v-for="user in userAllList"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </template>

                                        </el-select>
                                    </el-col>
                                    <el-col :sm="12" :xs="20">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                autosize
                                                placeholder="你想要感谢的是什么"
                                                @blur="formSubmit(item)"
                                                v-model="rel.content" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                        </el-input>
                                    </el-col>
                                    <el-col :sm="2" :xs="4">
                                        <el-button v-if="relIndex==0" :disabled="editIs==0" type="success" icon="el-icon-plus" circle size="small" @click="addQues(item)"></el-button>
                                        <el-button v-else type="danger" :disabled="editIs==0" icon="el-icon-minus" circle size="small" @click="minuQues(item,relIndex)"></el-button>
                                    </el-col>
                                </el-row>


                            </template>
                            <template v-else>
                                <el-input
                                        type="textarea"
                                        :rows="2"
                                        autosize
                                        placeholder="请输入内容"
                                        @blur="formSubmit(item)"
                                        v-model="item.answer" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                </el-input>
                            </template>

                        </div>
                    </div>
                </template>
                <div style="text-align: center">
                    <el-button v-if="editIs==1" type="danger" @click="formSubmit('')" :disabled="editIs==0">保存</el-button>
                    <template v-else >
                        <el-button :disabled="voitIs==0" type="primary" @click="showCommentDialog(1)">点赞</el-button>
                        <el-button v-if="formInline.classId!=3" type="danger" @click="showCommentDialog(2)">评论</el-button>
                    </template>
                </div>
            </div>
        </el-drawer>
        <el-dialog
                :title="dialogType==2?'评论原因(不少于50字)':'点赞原因(不少于50字)'"
                :visible.sync="showDialog"
                width="50%"
                center
                @close="closeLikeDialog">
            <el-input
                    type="textarea"
                    :rows="2"
                    autosize
                    placeholder="请输入内容(不少于50字)"
                    v-model="likeCommitContent" maxlength="5000" minlength="50" show-word-limit>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="likeCommitContent.length<50" @click="cooperativeLike(paperId,periodId)">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile} from '@/api/api';


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                quesList:[],
                weekValue:new Date(),
                weekText:'',
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    year:'',
                    period:'',
                    userId:''
                },
                recordsTotal:0,
                drawerShow:false,
                loading:false,
                editIs:0,
                voitIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:''
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.formInline.questionClassId = this.sectionClassId
            this.getCooperativeList()
            this.getCooperativeAllUserList()
            this.selectWeek(new Date())
        },
        methods: {
            //定义查询方法
            getCooperativeList() {
                this.$store.dispatch('initAllUserInterviewList',this.formInline).then(res=>{
                    this.dataList = res.data.list
                    this.recordsTotal = res.data.total
                })
            },
            getCooperativeQues(id,isEdit,isVoit,pId) {
                this.drawerShow = true;
                this.voitIs = isVoit;
                this.periodId = pId;
                this.paperId = id;
                this.editIs = isEdit;
                this.$store.dispatch('initCooperativeQues',{classId:this.formInline.classId,paperId:id}).then(res=>{
                    this.quesList = res
                    let arr = []
                    this.quesList.map(item=>{
                        if(item.questionType==3){
                            arr = JSON.parse(item.answer||'[]')
                        }
                    })
                    this.fileObjList = arr.map(item=>{
                        return {name:item.name,url:item.url}
                    })
                })
            },
            getCooperativeAllUserList() {
                this.$store.dispatch('initCooperativeAllUserList',{type:0,classId:''}).then(res=>{
                    this.userAllList = res
                    this.selectUserList1 = res
                    this.selectUserList = res
                })
            },
            cooperativeLike(id,pId) {
                this.loading=true;
                this.$store.dispatch('cooperativeLikeOrCancle',{periodId:pId,paperId:id,commit:this.likeCommitContent,voteType:this.dialogType}).then(res=> {
                    this.loading=false;
                    console.log(res)
                    this.$notify({
                        title: '成功',
                        message: res,
                        type: 'success'
                    });
                    this.showDialog=false
                    this.dialogType=1
                    this.drawerShow=false
                    this.likeCommitContent = ''
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeList()
            },
            handleClose(done) {
                this.quesList=[]
                this.voitIs = 0;
                this.editIs = 0;
                this.periodId = '';
                this.paperId = '';
                this.fileObjList = [];
                this.getCooperativeList()
                done();
            },
            formSubmit(obj){
                let _this = this;
                let subData = []
                let temRelation = [];
                if(obj){
                    if(obj.questionType==5){
                        temRelation = obj.relationEntityList.filter(item=>{
                            return (item.relationUserId!=null&&item.relationUserId!='')&&(item.content!=null&&item.content!='')
                        })
                    }
                    obj.answer = obj.questionType==3?JSON.stringify(_this.fileObjList):(obj.questionType==5?temRelation:(obj.answer||''))
                    subData = [obj]
                }else{
                    subData = this.quesList.map(item=>{
                        if(item.questionType==5){
                            temRelation = item.relationEntityList.filter(item1=>{
                                return (item1.relationUserId!=null&&item1.relationUserId!='')&&(item1.content!=null&&item1.content!='')
                            })
                        }
                        let newItem = {
                            paperId:item.paperId||'',
                            questionId:item.questionId||'',
                            answer:item.questionType==3?JSON.stringify(_this.fileObjList):(item.questionType==5?temRelation:(item.answer||''))
                        }
                        return newItem
                    })
                }

                console.log(subData)
                this.$store.dispatch('submitCooperativeQues',{answerEntityList:JSON.stringify(subData)}).then(res=>{
                    if(!obj){
                        this.drawerShow = false;
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success'
                        });
                    }

                })
            },
            handleFileChange(file,fileList){
                console.log(file)
                this.fileObjList = this.fileObjList.concat(file.value)
            },
            handleFileView(file){
                window.open(file.url)
            },
            handleFileRemove(file,fileList){
                this.fileObjList = fileList
            },
            querySearchFun(queryString) {
                var restaurants = this.userAllList;
                return queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            },
            querySearch(queryString) {
                this.selectUserList =this.querySearchFun(queryString);
            },
            querySearch1(queryString) {
                this.selectUserList1 = this.querySearchFun(queryString);
            },
            selectFocus(index){
                this.currentSelectIndex = index
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.USER_NAME.indexOf(queryString) >-1);
                }
            },
            addQues(item){
                let _this = this
                item.relationEntityList.push({
                    answerId: null,
                    content: null,
                    createTime: null,
                    id: null,
                    relationUserId: null,
                    relationUserName: null
                })
            },
            minuQues(item,index){
                item.relationEntityList.splice(index,1)
            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            selectWeek(val){
                this.$store.dispatch('cooperativeWeekInfo',{date:val}).then(res=>{
                    this.formInline.year = res.headYear
                    this.formInline.period = res.headPeriod

                })
            },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeFormAll.vue